function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1916(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.77,
    height: 14.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.047142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 7.165,
    fontFamily: "Arial"
  }, "\n        Cameron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14.33,
    width: 31.77,
    height: 15.6,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 22.13,
    fontFamily: "Arial"
  }, "\n        Forest\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 29.92,
    width: 31.77,
    height: 19.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.78
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 39.480000000000004,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 49.04,
    width: 31.77,
    height: 24.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.00125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 61.045,
    fontFamily: "Arial"
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 73.06,
    width: 31.77,
    height: 24.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.01
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 85.09,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 97.12,
    width: 31.77,
    height: 31.66,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.522857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 112.95,
    fontFamily: "Arial"
  }, "\n        Montour\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.78,
    width: 31.77,
    height: 33.38,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.538571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 145.47,
    fontFamily: "Arial"
  }, "\n        Juniata\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 162.16,
    width: 31.77,
    height: 37,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 180.66,
    fontFamily: "Arial"
  }, "\n        Snyder\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 199.16,
    width: 31.77,
    height: 38.73,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.538571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 218.525,
    fontFamily: "Arial"
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 237.89,
    width: 31.77,
    height: 38.95,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.354
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 257.365,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 276.84,
    width: 31.77,
    height: 52.82,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.538571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 303.25,
    fontFamily: "Arial"
  }, "\n        Mifflin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 329.66,
    width: 31.77,
    height: 53.99,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 356.65500000000003,
    fontFamily: "Arial"
  }, "\n        Potter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 383.64,
    width: 31.77,
    height: 58.09,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 412.685,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 441.73,
    width: 31.77,
    height: 59.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.354
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 471.475,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 501.22,
    width: 31.77,
    height: 61.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.354
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 531.76,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 562.31,
    width: 31.77,
    height: 64.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 594.4399999999999,
    fontFamily: "Arial"
  }, "\n        Elk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 626.56,
    width: 31.77,
    height: 73.44,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.885,
    y: 663.28,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 0,
    width: 45.93,
    height: 50.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.561428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 54.735,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.71,
    y: 0,
    width: 46.88,
    height: 50.91,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6971428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.14999999999999,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Clarion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124.59,
    y: 0,
    width: 46.89,
    height: 50.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.689
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.035,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Huntingdon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.48,
    y: 0,
    width: 52.99,
    height: 50.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 197.975,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.47,
    y: 0,
    width: 54.39,
    height: 50.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.628181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.665,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Susquehanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.86,
    y: 0,
    width: 54.48,
    height: 50.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.272857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 306.1,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Bedford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.34,
    y: 0,
    width: 55.79,
    height: 50.91,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.181999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.23499999999996,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.13,
    y: 0,
    width: 59.75,
    height: 50.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.181999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 419.005,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.88,
    y: 0,
    width: 61.58,
    height: 50.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 479.67,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        McKean\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 510.46,
    y: 0,
    width: 62.13,
    height: 50.91,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.656666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 541.525,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 572.59,
    y: 0,
    width: 62.9,
    height: 50.91,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.272857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 604.0400000000001,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Indiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.49,
    y: 0,
    width: 64.51,
    height: 50.91,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.745,
    y: 25.455,
    fontFamily: "Arial"
  }, "\n        Carbon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 50.91,
    width: 59.36,
    height: 55.87,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.311666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 78.845,
    fontFamily: "Arial"
  }, "\n        Centre\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 106.78,
    width: 59.36,
    height: 58.46,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 136.01,
    fontFamily: "Arial"
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 165.24,
    width: 59.36,
    height: 59.88,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 195.18,
    fontFamily: "Arial"
  }, "\n        Venango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 225.12,
    width: 59.36,
    height: 62.36,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 256.3,
    fontFamily: "Arial"
  }, "\n        Somerset\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 287.48,
    width: 59.36,
    height: 65.08,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 320.02000000000004,
    fontFamily: "Arial"
  }, "\n        Lebanon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 352.56,
    width: 59.36,
    height: 65.52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.595555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 385.32,
    fontFamily: "Arial"
  }, "\n        Armstrong\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 418.07,
    width: 59.36,
    height: 66.08,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 451.11,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 484.15,
    width: 59.36,
    height: 68.35,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 518.3249999999999,
    fontFamily: "Arial"
  }, "\n        Bradford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 552.51,
    width: 59.36,
    height: 73.6,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.893333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 589.31,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.77,
    y: 626.11,
    width: 59.36,
    height: 73.89,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 61.45,
    y: 663.0550000000001,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 50.91,
    width: 64.95,
    height: 71.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.495
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 123.61500000000001,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Cumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.09,
    y: 50.91,
    width: 65.49,
    height: 71.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.18625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 188.835,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.58,
    y: 50.91,
    width: 70.12,
    height: 71.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.0120000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 256.64,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Clearfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.7,
    y: 50.91,
    width: 72.51,
    height: 71.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.955,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.21,
    y: 50.91,
    width: 74.36,
    height: 71.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.94
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.39,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Beaver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 438.57,
    y: 50.91,
    width: 76.31,
    height: 71.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 476.725,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Lycoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.88,
    y: 50.91,
    width: 90.55,
    height: 71.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.155,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Bucks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 605.43,
    y: 50.91,
    width: 94.57,
    height: 71.64,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.328
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 652.7149999999999,
    y: 86.72999999999999,
    fontFamily: "Arial"
  }, "\n        Blair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 122.55,
    width: 95.02,
    height: 77.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5042857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.65,
    y: 161.07999999999998,
    fontFamily: "Arial"
  }, "\n        Northumberland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 199.61,
    width: 95.02,
    height: 78.55,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8549999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.65,
    y: 238.88500000000002,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 278.16,
    width: 95.02,
    height: 82.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.5025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.65,
    y: 319.165,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 360.17,
    width: 95.02,
    height: 82.94,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.848571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.65,
    y: 401.64,
    fontFamily: "Arial"
  }, "\n        Chester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 443.11,
    width: 95.02,
    height: 85.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.65,
    y: 485.70500000000004,
    fontFamily: "Arial"
  }, "\n        Cambria\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 528.31,
    width: 95.02,
    height: 85.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.227142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.65,
    y: 571.1049999999999,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.14,
    y: 613.9,
    width: 95.02,
    height: 86.1,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.827272727272727
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.65,
    y: 656.9499999999999,
    fontFamily: "Arial"
  }, "\n        Northampton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.15,
    y: 122.55,
    width: 88.39,
    height: 101.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.731666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.345,
    y: 173.195,
    fontFamily: "Arial"
  }, "\n        Lehigh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274.55,
    y: 122.55,
    width: 92.24,
    height: 101.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.67,
    y: 173.195,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.79,
    y: 122.55,
    width: 99.77,
    height: 101.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.252857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.675,
    y: 173.195,
    fontFamily: "Arial"
  }, "\n        Dauphin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.56,
    y: 122.55,
    width: 114.11,
    height: 101.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.3225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.615,
    y: 173.195,
    fontFamily: "Arial"
  }, "\n        York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.67,
    y: 122.55,
    width: 119.33,
    height: 101.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.254444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.3349999999999,
    y: 173.195,
    fontFamily: "Arial"
  }, "\n        Lancaster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.15,
    y: 223.83,
    width: 106.79,
    height: 114.45,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.679
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.54500000000002,
    y: 281.055,
    fontFamily: "Arial"
  }, "\n        Schuylkill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.15,
    y: 338.28,
    width: 106.79,
    height: 115.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.899166666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.54500000000002,
    y: 396.17499999999995,
    fontFamily: "Arial"
  }, "\n        Westmoreland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.15,
    y: 454.08,
    width: 106.79,
    height: 122.94,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.679
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.54500000000002,
    y: 515.55,
    fontFamily: "Arial"
  }, "\n        Lackawanna\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.15,
    y: 577.02,
    width: 106.79,
    height: 122.98,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 21.358
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 239.54500000000002,
    y: 638.51,
    fontFamily: "Arial"
  }, "\n        Berks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.95,
    y: 223.83,
    width: 173.57,
    height: 76.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.633
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 379.735,
    y: 261.995,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.52,
    y: 223.83,
    width: 233.48,
    height: 76.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.904285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.26,
    y: 261.995,
    fontFamily: "Arial"
  }, "\n        Luzerne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.95,
    y: 300.16,
    width: 132.51,
    height: 399.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.723333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 359.205,
    y: 500.08000000000004,
    fontFamily: "Arial"
  }, "\n        Allegheny\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 425.46,
    y: 300.16,
    width: 274.54,
    height: 399.84,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.878333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.73,
    y: 500.08000000000004,
    fontFamily: "Arial"
  }, "\n        Philadelphia\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1916);
export default __webpack_public_path__ + "static/media/1916.be2af867b5e7c2178ad48f475935fc53.svg";
export { ForwardRef as ReactComponent };